import React from 'react';
import { func } from 'prop-types';
import ImportActions from '../../shared/ImportActions';

const NoDefinition = ({ setView }) => {
  return (
    <div className="de--createNew">
      <div className="de--createNew--header">
        <h2 className="de--createNew--title">
          There are no campaign targets to display!
        </h2>
        <p className="de--createNew--message">
          To add targets to the table you can import a previously saved
          definition or create a new target.
        </p>
      </div>
      <ImportActions setView={setView} />
    </div>
  );
};

NoDefinition.propTypes = {
  setView: func,
};

export default NoDefinition;
